module.exports = __webpack_public_path__ + "static/media/screen-left.4de78bc5.png";